'use client';

import { PropsWithChildren, useState } from 'react';

import { HeaderVisibilityContext } from './HeaderVisibilityContext';

export const HeaderVisibilityProvider = ({ children }: PropsWithChildren) => {
  const [headerVisible, setHeaderVisible] = useState<boolean>(true);

  return (
    <HeaderVisibilityContext.Provider
      value={{ headerVisible, setHeaderVisible }}
    >
      {children}
    </HeaderVisibilityContext.Provider>
  );
};
